<accordion>
  <accordion-group>
    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
      <div class="pull-left float-left">I can have markup!</div>
      <span class="badge badge-secondary float-right pull-right">Some HTML here</span>
    </button>
    This is just some content to illustrate fancy headings.
  </accordion-group>
  <accordion-group>
    <button class="btn btn-link" accordion-heading type="button">
      I can have markup, too!
    </button>
    <span class="badge badge-secondary center">And some HTML here</span>
  </accordion-group>
</accordion>
